export default __webpack_public_path__ + "static/media/Target.196fca48.svg";